import React from 'react';
import { Card, CardHeader, CardContent, CardActionArea, Typography, Grid } from '@mui/material';
import { saveAs } from 'file-saver';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ButtonNav from '../button/ButtonNav';

export default function CardPaiement({ selected = false, disabled = false, desc, tarif, tarifRef, montantRemise, displayPrix, actionSelectTypePaiement }) {

	const telechargerConditionsTarifaires = () => {
		saveAs(process.env.REACT_APP_PATH_PDF + '/Conditions_Tarifaires_Dépannage_ELLIAN.pdf', 'Conditions Tarifaires Dépannage ELLIAN.pdf');
	};

	return (
		<Card sx={{ color: '#555555', backgroundColor: selected ? '#F7F7F7' : '', borderRadius: 2, boxShadow: 2, border: 2, borderColor: selected ? '#004afe' : '' }} >
			<CardActionArea onClick={() => actionSelectTypePaiement(desc.type, tarif)} disabled={disabled}>

				{selected &&
					<CheckCircleIcon sx={{ m: 1, color: disabled ? '#cccccc' : '#004afe', position: 'absolute' }} />
				}

				<CardHeader
					sx={{ p: 1, pb: 0, px: 5, color: '#004afe', textAlign: 'center' }}
					titleTypographyProps={{ fontSize: 18, fontWeight: 600 }}
					title={desc.titre}
					subheader={desc.soustitre}
					subheaderTypographyProps={{ color: '#004afe', fontSize: 14, fontWeight: 400 }}
				/>

				<CardContent sx={{ p: 0, pb: 1 }} >

					{displayPrix &&
						<>

							{montantRemise > 0 &&
								<Typography component="p" align="center" mt={1}>
									<Typography component="span" variant="price_mini_barre">{tarif.montantTotal}€</Typography>
									<Typography component="span" sx={{ fontSize: 18 }}> (-{montantRemise}€ de remise)</Typography>
								</Typography>
							}

							<Typography component="p" align="center" variant="price">
								{tarif.montantTotal - montantRemise} <Typography component="span" align="center" variant="currency" sx={{ ml: -1.5 }}>€</Typography>
							</Typography>

							{desc.type === "PAIEMENT_2FOIS" &&
								<>
									<Typography component="p" align="center">Maintenant : <Typography component="span" sx={{ fontSize: 20, fontWeight: 800 }} >{tarif.montantReservation}€</Typography></Typography>
									<Typography component="p" align="center">Jour intervention : <Typography component="span" sx={{ fontSize: 20, fontWeight: 800 }} >{tarif.montantIntervention - montantRemise}€</Typography></Typography>
								</>
							}

							<Typography component="p" align="center" variant="p">
								{desc.type !== "PAIEMENT_2FOIS" ?
									<>
										<Typography component="span">J'économise&nbsp;</Typography>
										<Typography component="span" sx={{ color: 'LimeGreen', fontSize: 20, fontWeight: 600 }}>{(tarifRef - tarif.montantTotal)}€</Typography>
									</>
									:
									<>
										<Typography component="span">Tarif de référence</Typography>
										<Typography component="span" sx={{ fontSize: 20, fontWeight: 600 }}>&nbsp;</Typography>
									</>
								}
							</Typography>

						</>
					}

				</CardContent>

			</CardActionArea>

			{!displayPrix &&
				<Grid container justifyContent="center" my={2}>
					<Grid item xs={10} sm={8} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
						<ButtonNav props={{ text: 'Télécharger nos conditions tarifaires' }} action={telechargerConditionsTarifaires} />
					</Grid>
				</Grid>
			}

		</Card>
	);
}